import { render } from "./Table2.vue?vue&type=template&id=f380502c"
import script from "./Table2.vue?vue&type=script&lang=js"
export * from "./Table2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__